import {createRouter, createWebHistory} from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'Home',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Home.vue'),
    meta: {
      requiresAuth: false,
    }
  },
  {
    path: process.env.VUE_APP_PATH_SUB + '/',
    name: 'Home',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Home.vue'),
    meta: {
      requiresAuth: false,
    }
  },
  {
    path: process.env.VUE_APP_PATH_SUB + '/:url',
    name: 'Page',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Page.vue'),
    meta: {
      requiresAuth: false,
    }
  },
  {
    path: process.env.VUE_APP_PATH_SUB + '/:url1/:url',
    name: 'Page2',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Page.vue'),
    meta: {
      requiresAuth: false,
    }
  },
  {
    path: '/:catchAll(.*)',
    name: 'e404',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/e404.vue'),
    meta: {
      requiresAuth: false,
    }
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return {x: 0, y: 0};
  },
})

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (localStorage.getItem('access_token') == null) {
      next({
        path: '/login',
        params: {nextUrl: to.fullPath},
        query: {
          backUrl: window.location.pathname + window.location.search,
        }
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
